var PassengerType = /* @__PURE__ */ ((PassengerType2) => {
  PassengerType2["CHILD"] = "child";
  PassengerType2["YOUTH"] = "youth";
  PassengerType2["ADULT"] = "adult";
  PassengerType2["SENIOR"] = "senior";
  PassengerType2["GROUP"] = "group";
  return PassengerType2;
})(PassengerType || {});
export {
  PassengerType
};
